module.exports = __webpack_public_path__ + "4874ad31a02b337937746c3206003363.png";